import { render, staticRenderFns } from "./help.vue?vue&type=template&id=8d54050c&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&id=8d54050c&prod&lang=scss&scoped=true&"
import style1 from "./help.vue?vue&type=style&index=1&id=8d54050c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d54050c",
  null
  
)

export default component.exports